<h1 class="mat-h1" mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <span class="mat-body">{{data.text}}</span>
</div>
<div mat-dialog-actions>
  <button mat-button color="warn" (click)="onDiscard()">Non</button>
  <button mat-button color="primary" (click)="onValidate()" cdkFocusInitial>Oui</button>
</div>
